import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PosProfileFormWrapperComponent } from '../components/pos-profile-form-wrapper/pos-profile-form-wrapper.component';
import { 
  PosProfileFormConfig,
  getPosProfileFormConfig
} from '../pos-profile.config';
import { PosProfileService } from '../services/pos-profile.service';

@Component({
  selector: 'app-pos-profile-add',
  standalone: true,
  imports: [PosProfileFormWrapperComponent],
  templateUrl: './pos-profile-add.component.html',
  styleUrls: ['./pos-profile-add.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PosProfileAddComponent {
  private posProfileService = inject(PosProfileService);
  
  config: PosProfileFormConfig = getPosProfileFormConfig(this.posProfileService);
}
